import { useEffect, useLayoutEffect, useMemo, useRef } from 'react'; // Utils for Popper and Dropdown components

export function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
export function useForkRef(refA, refB) {
  return useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}
export function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // tslint:disable-next-line:no-invalid-this
      acc.apply(this, args); // tslint:disable-next-line:no-invalid-this

      func.apply(this, args);
    };
  }, function () {});
} // tslint:disable-next-line:no-typeof-undefined

export var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}
export var wrapEvent = function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    if (theirHandler) {
      theirHandler(event);
    }

    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
};
export function assignRef(ref, value) {
  if (ref == null) return;

  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
  }
}
export function mergeRefs() {
  for (var _len3 = arguments.length, refs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    refs[_key3] = arguments[_key3];
  }

  return function (value) {
    refs.forEach(function (ref) {
      return assignRef(ref, value);
    });
  };
}